var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("span", { staticClass: "text-uppercase field-label" }, [
      _vm._v("Owner")
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "lead-coordinator cursor-pointer",
        on: { click: _vm.showChangeCoordinator }
      },
      [
        _c("span", { staticClass: "info-bubbles" }, [
          _vm.deliverable.lead_coordinator
            ? _c(
                "span",
                {
                  directives: [
                    {
                      name: "b-tooltip",
                      rawName: "v-b-tooltip.hover.html",
                      modifiers: { hover: true, html: true }
                    }
                  ],
                  staticClass: "initials badge",
                  class: _vm.getColorClass(),
                  attrs: { title: _vm.deliverable.lead_coordinator.name }
                },
                [
                  _c("span", { staticClass: "exclude-outside-click" }, [
                    _vm._v(
                      _vm._s(
                        _vm._f("textInitials")(
                          _vm.deliverable.lead_coordinator.name
                        )
                      )
                    )
                  ])
                ]
              )
            : _c(
                "span",
                {
                  directives: [
                    {
                      name: "b-tooltip",
                      rawName: "v-b-tooltip.hover.html",
                      modifiers: { hover: true, html: true }
                    }
                  ],
                  staticClass: "initials badge badge-primary",
                  attrs: {
                    title: _vm.deliverable.tasks[0].taskFields[0].userName
                  }
                },
                [
                  _c("span", { staticClass: "exclude-outside-click" }, [
                    _vm._v(
                      _vm._s(
                        _vm._f("textInitials")(
                          _vm.deliverable.tasks[0].taskFields[0].userName
                        )
                      )
                    )
                  ])
                ]
              )
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "add-multiselect-group" },
          [
            _c("plus-button"),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.changeCoordinatorFlag,
                    expression: "changeCoordinatorFlag"
                  }
                ],
                staticClass: "custom-field user-field custom-multiselect"
              },
              [
                _c("multiselect", {
                  directives: [
                    {
                      name: "click-outside",
                      rawName: "v-click-outside",
                      value: _vm.outside,
                      expression: "outside"
                    }
                  ],
                  ref: "deliverableListCoordinators",
                  attrs: {
                    options: _vm.groupedUser,
                    "show-labels": true,
                    multiple: false,
                    "allow-empty": false,
                    "open-direction": "bottom",
                    label: "name",
                    "track-by": "id"
                  },
                  on: {
                    close: function($event) {
                      _vm.changeCoordinatorFlag = false
                    },
                    input: function($event) {
                      _vm.changeLeadCoordinator(_vm.deliverable)
                      _vm.changeCoordinatorFlag = false
                    }
                  },
                  model: {
                    value: _vm.deliverable.lead_coordinator,
                    callback: function($$v) {
                      _vm.$set(_vm.deliverable, "lead_coordinator", $$v)
                    },
                    expression: "deliverable.lead_coordinator"
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }